export default __webpack_public_path__ + "static/media/task_icon.d2f2ef1c.png";